import { useEffect } from 'react'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import { setPreferredPractitioners, useChoiceDispatch } from '@context/ChoiceContext'

export const useResetPreferredPractitionersInMultipleCLinics = () => {
  const { isMoreClinicsOpen } = useAppointmentCalendar()
  const choiceDispatch = useChoiceDispatch()

  useEffect(() => {
    if (isMoreClinicsOpen) choiceDispatch(setPreferredPractitioners([]))
  }, [isMoreClinicsOpen, choiceDispatch])
}
